// ==================================== COMPONENTS =========================================
// THIRD PARTY/ CORE COMPONENTS
import React from 'react';
import propTypes from 'prop-types';

// USER COMPONENTS
import { Button } from '../../../components/buttons/buttons';
import { Modal } from '../../../components/modals/antd-modals';
import { BasicFormWrapper } from '../../styled';

const DeleteReferral = ({ visible, onCancel, referral, handleDelete }) => {
  // To handle delete button 
  const handleSubmit = () => {
    handleDelete(referral?._id)
    onCancel();
  }

  return (
    <Modal
      type={'primary'}
      title="Delete referral lead"
      visible={visible}
      footer={[
        <div key="1" className="model-modal-footer">
          <Button size="default" style={{ backgroundColor: '#155BDC', color: '#fff' }} key="submit" onClick={handleSubmit}>
            Delete Referral Lead
          </Button>
          <Button size="default" type="white" key="back" outlined onClick={onCancel}>
            Cancel
          </Button>
        </div>,
      ]}
      onCancel={onCancel}
    >
      <div className="model-modal">
        <BasicFormWrapper>
          <p>Are you sure you want to delete this referral lead?</p>
        </BasicFormWrapper>
      </div>
    </Modal>
  );
};

DeleteReferral.propTypes = {
  visible: propTypes.bool.isRequired,
  onCancel: propTypes.func.isRequired,
};

export default DeleteReferral;